import "./GameServicesOverview.css";

const services = [
  "End-to-End Development",
  "Unity Tools",
  "UI Design",
  "Environment Design",
  "Custom Features",
  "Multiplayer",
  "Visual Effects",
  "Game Optimization",
  "Game Prototype",
  "Analytics",
  "Localization"
];

const GameServicesOverview = () => {
  return (
    <section className="game-overview">

      <div className="game-overview-container">

        <span className="game-overview-badge">
          GAME DEVELOPMENT
        </span>

        <h2>
          Everything Your Game Needs,
          <span> Under One Roof</span>
        </h2>

        <p>
          From concept to launch, we provide complete Unity game development
          services including gameplay programming, multiplayer, UI/UX,
          environments, optimization, VFX, analytics and post-launch support.
        </p>

        <div className="game-service-pills">

          {services.map((service, index) => (
            <button
              key={index}
              className="game-pill"
            >
              {service}
            </button>
          ))}

        </div>

      </div>

    </section>
  );
};

export default GameServicesOverview;